import { FunctionComponent, useContext, useEffect, useState } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import EmployerSearch from "../../../components/employer-search";
import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { TransferContext } from "../../../context/TransferContext";
import HeadingContainer from "../../../layout/heading-container";
import { BodyLargeRegular, TitleLarge } from "../../../components/font";
import { Button, tokens } from "@manifesthhqinc/ui-library";

const SponsorNameScreen: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const [hasCompletedSourceAccount, setHasCompletedSourceAccount] = useState<boolean>(false);
  const { transferDetails } = useContext(TransferContext);
  const {
    currentSourceAccountStep,
    currentOldAccountDetails,
    userDetails,
    updateOldAccountDetails,
    onClickContinue,
    employerAPI,
    setIsSaving,
    isSaving,
  } = props;

  const onClickContinueHandler = () => {
    setIsSaving(true);
    onClickContinue();
  };

  useEffect(() => {
    const completedSourceAccounts = transferDetails.sourceAccounts.filter(
      (s) => s.isCompleted && s.sourceAccountId !== currentOldAccountDetails.sourceAccountId,
    );
    if (completedSourceAccounts.length > 0) {
      setHasCompletedSourceAccount(true);
    }
  }, []);

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer withProgressBar paneVariant="form">
            <TitleLarge>
              Hi {userDetails.firstName},{" "}
              {hasCompletedSourceAccount
                ? `let’s begin with the details for your next old account`
                : `let’s start with locating your old account`}
            </TitleLarge>
            <BodyLargeRegular $color={tokens.color.text.secondary}>
              Provide your old employer name so we can help you verify your old provider (e.g., Fidelity, TIAA, etc.).
            </BodyLargeRegular>
          </HeadingContainer>

          <EmployerSearch
            value={
              currentOldAccountDetails.planSponsor
                ? {
                    label: currentOldAccountDetails.planSponsor,
                    value: currentOldAccountDetails.planSponsorId,
                  }
                : undefined
            }
            error={false}
            readOnly={false}
            name="search-employer-name"
            onChange={(e) =>
              updateOldAccountDetails({
                planSponsor: e?.label,
                planSponsorId: e?.__isNew__ ? "" : e?.value,
              })
            }
            api={employerAPI}
          />
        </Container>
      </ScrollableContainer>

      {currentOldAccountDetails.planSponsor && (
        <Footer>
          <Button size="large" onClick={onClickContinueHandler} name="continue" isLoading={isSaving}>
            Continue
          </Button>
        </Footer>
      )}
    </TransitionWrapper>
  );
};

export default SponsorNameScreen;
